import React from 'react';
import { Button } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import constants from '../../../constants';

interface SimplePagingProps {
  currentPage?: number;
  onClickPrePageBtn: () => void;
  onClickNextPageBtn: () => void;
  dataLength: number;
}

const SimplePaging: React.FC<SimplePagingProps> = ({ currentPage, onClickPrePageBtn, onClickNextPageBtn, dataLength }: SimplePagingProps) => {

  const preBtnIsDisabled = currentPage === 1;
  const nextBtnIsDisabled = dataLength < constants.PAGE_SIZE;

  return (
    <div>
      <Button value="pre" shape="circle" disabled={preBtnIsDisabled} size="small" icon={<LeftOutlined />}
              onClick={(e) => onClickPrePageBtn()}
      />
      <span style={{ padding: '0 8px' }}>{currentPage} page</span>
      <Button value="next" shape="circle" disabled={nextBtnIsDisabled} size="small" icon={<RightOutlined />}
              onClick={(e) => onClickNextPageBtn()}
      />
    </div>
  );
};

export default SimplePaging;
